import { functions, db } from '@/firebase/init';
import  _  from 'lodash';
import Vue from 'vue'
import moment from 'moment';
import storeGetters from '../store'

export default {
	namespaced: true,
	state: {
		notifications: [],
		lastFourNotifications: [],
		notificationListener: null,
		lastTenJobLogs: [],
		list: [],
		upListen: null,
		downListen: null,
		jobLogListen: null,
		outages: [],
		announcementListener: null,
		announcementText: '',
		announcementType: 'alert-info',
		announcementDocId: ''
	},
	getters: {
		getAnnouncementListener(state){
			return state.announcementListener;
		},
		getAnnouncementText(state){
			return state.announcementText;
		},
		getAnnouncementType(state){
			return state.announcementType;
		},
		getAnnouncementDocId(state){
			return state.announcementDocId;
		},
		details(state) {
			return state.notifications
		},
		notificationList(state) {
			return state.list
		},
		getNotificationListener(state){
			return state.notificationListener;
		},
		getLastFourNotifications(state){
			return state.lastFourNotifications;
		},
		getAllOutages(state){
			return state.outages;
		},
		getLastTenJobLogs (state) {
			return state.lastTenJobLogs;
		}
	},
	mutations: {
		mutateAnnouncementListener(state, payload) {
			state.announcementListener = payload;
		},
		mutateAnnouncementText(state, payload) {
			state.announcementText = payload;
		},
		mutateAnnouncementType(state, payload) {
			state.announcementType = payload;
		},
		mutateAnnouncementDocId(state, payload) {
			state.announcementDocId = payload;
		},
		updateOutages(state, payload){
			if(payload.op === 'remove'){
				console.log('Removing');
				console.log(payload.test);
				state.outages = state.outages.filter(test => test.testId !== payload.test.testId);
				console.log(state.outages);
			}else{
				state.outages.push(payload.test);
			}
		},
		removeOutages(state){
			state.outages = [];
		},
		updateAdminNotificationListener(state, payload){
			if (payload.type === 'Up') {
				state.upListen = payload.listen;
			} else if (payload.type === 'Down') {
				state.downListen = payload.listen;
			} else if (payload.type === 'jobLog') {
				state.jobLogListen = payload.listen;
			}
		},
		updateNotificationListener(state, payload) {
			state.notificationListener = payload;
		},
		lastFourNotificationsMutate(state, payload){
			state.lastFourNotifications = payload;
		},
		lastTenJobLogsMutate(state, payload){
			state.lastTenJobLogs = payload;
		},
		notificationsMutate(state, payload) {
			state.notifications = payload;
		},
		notificationMutate(state, payload) {
			state.notifications.push(payload);
			state.notifications = _.orderBy(state.notifications, ['createdAt'], ['desc']);
		},
		removeNotification(state, payload) {
			state.notifications = _.filter(state.notifications, (item)=>item.docID !== payload.docID);
		},
		listMutate(state, payload) {
			state.list = payload;
			state.list = _.orderBy(state.list, ['createdAt'], ['desc']);
		},
		updateListItem(state, payload) {
			state.list = _.map(state.list, (item)=>{
				// TODO: replace to object not static data
				if(item.docID === payload.docID){
					item.read = true;
                    item.status = true;
				}
				return item;
			})
		},
		removeListItem(state, payload) {
			state.list = _.filter(state.list, (item)=>item.docID !== payload.docID);
		}
	},
	actions: {
		fetchJoblogs(context){
			let query = db.collection('jobLogs')
				.orderBy('createdAt', 'desc')
				.limit(10);
			let latestJoblogs = [];
			let jobLogListen = query.onSnapshot(snapshot => {
				latestJoblogs = [];
				snapshot.docs.forEach((doc) => {
					latestJoblogs.push(doc.data());
				});
				context.commit('lastTenJobLogsMutate', latestJoblogs);
			})
			context.commit('updateAdminNotificationListener', {type: 'jobLog', listen: jobLogListen});
		},
		fetchNotifications(context) {
			// Set loaded to false
			let query = db.collection('users').doc(context.rootGetters.getUID)
				.collection('notifications')
				.orderBy('createdAt', 'desc')
				.where('read', '==', false);

			const listener = query.onSnapshot(querySnapshot => {
				querySnapshot.docChanges().forEach(change => {
					if (change.type === 'added') {
						console.log('Notification Added...');
						const notificationData = change.doc.data();
						console.log(notificationData);
						if(notificationData.status === 'complete'){
							context.commit('notificationMutate', {
								docID: change.doc.id,
								...change.doc.data()
							});
						}else{
							console.log('Pending notification registered! Showing Loader in header');
							context.commit('updateBackendJobLoading', true, {root:true});
						}
					}
					if (change.type === 'modified') {
						context.commit('updateBackendJobLoading', false, {root:true});
						console.log('Notification Modified...');
						const notificationData = change.doc.data();
						console.log(notificationData);
						if (!notificationData.read && notificationData.status === 'complete' && !context.rootGetters.isShowNotificationOnLoggedIn) {

							Vue.notify({
								group: 'foo',
								title: notificationData.from.name,
								duration: 5000,
								text: notificationData.message,
								type: (notificationData.type === 'info') ? 'info' : 'error'
							});
							const sound = new Audio('/eventually.mp3');
							sound.play();
						}
						switch (notificationData.from.type) {
							case 'STAGING':
								context.commit('updateStagingRequested', false, {root:true});
								break;
							case 'CLONING':
								context.commit('updatePushToLiveRequested', false, {root:true});
								context.commit('updateBackupActions', {
									value: '',
									type: false,
									input: false
								}, {root: true});
								break;
							case 'BACKUP':
								context.commit('updateBackupActions', {
									value: '',
									type: false,
									input: false
								}, {root: true});
								break;
							case 'FreshInstall':
								context.commit('updateFreshWordPressDisable', false, {root: true});
								break;
							case 'PHPMYADMIN-FIX':
								context.commit('mutateFixPhpMyAdminLoader', false, {root: true});
								break;
							case 'PERMISSIONS-FIX':
								context.commit('mutateFixPermissionsLoader', false, {root: true});
								break;
						}
						context.commit('notificationMutate', {
							docID: change.doc.id,
							...change.doc.data()
						});
					}
					if (change.type === 'removed') {
						context.commit('removeNotification', {docID: change.doc.id});
					}
				});
				context.dispatch('fetchLastFourNotifications');
				context.commit('updateShowNotificationOnLogIn', false, {root:true});
			}, err => {
				console.log(`Encountered error: ${err}`);
			});
			context.commit('updateNotificationListener', listener);
		},
		fetchListNotification(context, playload){
            return new Promise((resolve, reject)=> {
                const fetchClientNotifications = functions.httpsCallable(
                      "getLastNotifications"
                  );
                  fetchClientNotifications(playload)
                      .then(response => {
                          const data = response.data.data;
                          context.commit('listMutate', data);
                          resolve(data);
                      })
                      .catch(err => {
                          console.log(err.message);
                          reject(err);
                      });
                });
		},
		fetchLastFourNotifications(context){
			let query = db.collection('users').doc(context.rootGetters.getUID)
				.collection('notifications')
				.where('status', '==', 'complete')
				.orderBy('createdAt', 'desc')
				.limit(4);
			const latestNotifications = [];
			query.get().then(snapshot => {
				snapshot.forEach((doc) => {
					latestNotifications.push(doc.data());
				});
				context.commit('lastFourNotificationsMutate', latestNotifications);
			})
		},
		updateNotification(context, {UID, docID}) {
			// Set loaded to false
			const updateNotification = functions.httpsCallable(
				"updateNotification"
			);
			return new Promise((resolve, reject)=> {
				return updateNotification({ UID: UID, notificationId: docID, markAsRead: true, status: true })
					.then(() => {
						context.commit('updateListItem', {docID});
						resolve(docID);
					})
					.catch(err => {
						reject(err);
					})
			});
		},
		removeNotification(context, {docID}) {
			// Set loaded to false
			const removeNotification = functions.httpsCallable(
				"deleteNotification"
			);
			return new Promise((resolve, reject)=> {
			return removeNotification({ notificationId: docID })
				.then(() => {
					context.commit('removeListItem', {docID});
					resolve(true);
				})
				.catch(err => {
					reject(err);
				})
			});
		},
		resetNotifications(context){
			context.commit('notificationsMutate', []);
		},
		// adminNotifications(context){
		// 	const isNotifications = context.rootGetters.isNotifications;
		// 	const muteNotiFlag = context.rootGetters.muteNotiFlag;
		// 	if(isNotifications){
		// 		let upQuery = null;
		// 		let downQuery = null;
		// 		upQuery = db.collection('status_cake_tests')
		// 			.where('status', '==', 'Up')
		// 			.where('updatedAt', '>=', moment().subtract(1, 'days').toISOString());
		// 		downQuery = db.collection('status_cake_tests')
		// 			.where('status', '==', 'Down');
		// 		let upL = upQuery.onSnapshot((querySnapshot) => {
		// 			querySnapshot.docChanges().forEach(change => {
		// 				if(change.type === 'added' && !context.rootGetters.isUpNoti) {
		// 					console.log('New Up....');
		// 					if(muteNotiFlag){
		// 						const sound = new Audio('/noti.wav');
		// 						sound.play();
		// 					}
		//
		// 				}
		// 			});
		// 			context.commit('updateAdminNotificationOnLogin', {type: 'Up', status: false}, {root:true});
		// 		});
		// 		context.commit('updateAdminNotificationListener', {type: 'Up', listen: upL});
		// 		let downL = downQuery.onSnapshot((querySnapshot) => {
		// 			querySnapshot.docChanges().forEach(change => {
		// 				console.log(change);
		// 				if(change.type === 'added' && !context.rootGetters.isDownNoti) {
		// 					console.log('New Down....');
		// 					if(muteNotiFlag) {
		// 						const sound = new Audio('/noti.wav');
		// 						sound.play();
		// 					}
		// 				}
		// 				if(change.type === 'added'){
		// 					context.commit('updateOutages', {op: 'add', test: change.doc.data()});
		// 				}
		// 				if(change.type === 'removed'){
		// 					context.commit('updateOutages', {op: 'remove', test: change.doc.data()});
		// 				}
		// 			});
		// 			context.commit('updateAdminNotificationOnLogin', {type: 'Down', status: false}, {root:true});
		// 		});
		// 		context.commit('updateAdminNotificationListener', {type: 'Down', listen: downL});
		// 	}
		// },
		 adminNotifications(context){
			const isNotifications = context.rootGetters.isNotifications;
			const muteNotiFlag = context.rootGetters.muteNotiFlag;
			const testIps = ['69.162.173.212', '23.29.145.209']
			if(isNotifications){
				let upQuery = null;
				let downQuery = null;
				upQuery = db.collection('monitors')
					.where('status', '==', 'up')
					.where('updatedAt', '>=', moment().subtract(1, 'days').toISOString());
				downQuery = db.collection('monitors')
					.where('status', '==', 'down');
				let upL = upQuery.onSnapshot((querySnapshot) => {
					querySnapshot.docChanges().forEach(change => {
						if(change.type === 'added' && !context.rootGetters.isUpNoti) {
							console.log('New Up....');
							if(muteNotiFlag){
								// const sound = new Audio('/noti.wav');
								// sound.play();
							}

						}
					});
					context.commit('updateAdminNotificationOnLogin', {type: 'Up', status: false}, {root:true});
				});
				context.commit('updateAdminNotificationListener', {type: 'Up', listen: upL});
				let downL = downQuery.onSnapshot((querySnapshot) => {
					querySnapshot.docChanges().forEach(change => {
						console.log(change);
						if(change.type === 'added' && !context.rootGetters.isDownNoti) {
							console.log('New Down....', muteNotiFlag);
							// check if it is ack then no sound
							const { incidents, serverIP } = change.doc.data();
							const lastIncident = incidents[incidents.length - 1].acknowledgedBy || null;
							const userBreakFlag = storeGetters.getters.user.isOnBreakOrSignedOut;
							console.log(muteNotiFlag , !lastIncident , !userBreakFlag)
							if(muteNotiFlag && !lastIncident && !testIps.includes(serverIP) && !userBreakFlag) {
								console.log("I will be played")
								const sound = new Audio('/noti.wav');
								sound.play();
							}
						}
						if(change.type === 'added'){
							context.commit('updateOutages', {op: 'add', test: {testId: change.doc.id, ...change.doc.data()}});
						}
						if(change.type === 'removed'){
							context.commit('updateOutages', {op: 'remove', test: {testId: change.doc.id, ...change.doc.data()}});
						}
					});
					context.commit('updateAdminNotificationOnLogin', {type: 'Down', status: false}, {root:true});
				});
				context.commit('updateAdminNotificationListener', {type: 'Down', listen: downL});
			}
		},
		resetAdminListens(context){
			console.log('Release admin notification listener');
			if(context.state.upListen){
				context.state.upListen();
			}
			if(context.state.downListen){
				context.state.downListen();
			}
			if(context.state.jobLogListen){
				context.state.jobLogListen();
			}
		}
	}
}
